import { useAppSelector } from "../app/store";
import { Role } from "../types";

export default function useAuth(roles?: Role[]) {
  const { access_token, role } = useAppSelector((state) => state.auth);

  const accessRole = role && roles?.length && roles?.includes(role);

  return access_token && (roles?.length ? accessRole : true);
}
